
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 40 40"}},[_c('path',{attrs:{"d":"M26.666 6.666a3.322 3.322 0 00-3.333-3.333h-6.667a3.322 3.322 0 00-3.333 3.333V10h-3.325v25h19.983V10h-3.325zM23.333 10h-6.667V6.666h6.667zm10 0h-.008v25h.008a3.322 3.322 0 003.333-3.333V13.333A3.322 3.322 0 0033.333 10zM3.35 13.333l-.017 18.334A3.322 3.322 0 006.663 35h.008V10h-.008a3.308 3.308 0 00-3.313 3.333z"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      